import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import CircularProgress from "@material-ui/core/CircularProgress";
import Avatar from "@material-ui/core/Avatar";
import { white } from "../styles/color";
class Loading extends React.Component {
  render() {
    console.log("IN loading page");
    return (
      <div
        style={{
          height: window.innerHeight - 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
          flexDirection: "column"
        }}
      >
        <Avatar
          style={{
            boxShadow:
              "0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)",
            backgroundColor: white,
            height: "50px",
            width: "50px"
          }}
        >
          <CircularProgress />
        </Avatar>
        <span style={{ marginTop: "10px" }}>
          Please wait page is loading......
            </span>
      </div>
    );
  }
}
export default withStyles()(withRouter(Loading));
